import {
  Analytics,
  logEvent as firebaseLogEvent,
  getAnalytics,
} from 'firebase/analytics';
import {initializeApp} from 'firebase/app';

import {FIREBASE_CONFIG} from '@/shared/config';

let analytics: Analytics | null = null;
let enabled = false;

export function logEvent(eventName: string, eventParams?: Record<string, any>) {
  if (!enabled) {
    return;
  }

  if (!analytics) {
    const app = initializeApp(FIREBASE_CONFIG);
    analytics = getAnalytics(app);
  }

  firebaseLogEvent(analytics, eventName, eventParams);
}

export function initFirebaseAnalytics() {
  enabled = true;
}
